import React, { useState, useEffect } from "react";
import { array, string, func, number } from "prop-types";
import { BulletList } from "../../atoms/icon/icons/bullet-list";

import "./tab-navigation.m.css";
import { Icon } from "../../atoms/icon";

export const TabNavigation = ({
  tabs = [],
  activeTab = 0,
  onTabChange,
  className = "",
  ...props
}) => {
  const [activeIndex, setActiveIndex] = useState(activeTab);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (showMobileMenu) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    }

    // Cleanup on unmount
    return () => {
      if (typeof window !== 'undefined') {
        document.body.style.overflow = 'unset';
      }
    };
  }, [showMobileMenu]);

  const handleTabClick = (index, tab) => {
    setActiveIndex(index);
    setShowMobileMenu(false); // Close mobile menu when tab is selected
    if (onTabChange) {
      onTabChange(index, tab);
    }
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <div styleName="tab-navigation" className={className} {...props}>
      {/* Desktop Tab Navigation */}
      <div styleName="tab-list">
        {tabs.map((tab, index) => (
          <button
            key={tab.id || index}
            type="button"
            styleName={`tab-item ${index === activeIndex ? 'active' : ''}`}
            onClick={() => handleTabClick(index, tab)}
            disabled={tab.disabled}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Mobile Navigation Button */}
      {!showMobileMenu && <button
        type="button"
        styleName="mobile-menu-button"
        onClick={toggleMobileMenu}
        aria-label="Toggle navigation menu"
      >
        <BulletList size={24} />
      </button>}

      {/* Mobile Menu Modal */}
      {showMobileMenu && (
        <div styleName="mobile-menu-overlay" onClick={() => setShowMobileMenu(false)}>
          <div styleName="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div styleName="mobile-menu-header">
              <h3>Navigation</h3>
              <button
                type="button"
                onClick={() => setShowMobileMenu(false)}
                aria-label="Close menu"
              >
                <Icon name="close" size="xsmall" />
              </button>
            </div>
            <div styleName="mobile-menu-list">
              {tabs.map((tab, index) => (
                <button
                  key={tab.id || index}
                  type="button"
                  styleName={`mobile-menu-item ${index === activeIndex ? 'active' : ''}`}
                  onClick={() => handleTabClick(index, tab)}
                  disabled={tab.disabled}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

TabNavigation.propTypes = {
  tabs: array.isRequired,
  activeTab: number,
  onTabChange: func,
  className: string
};